import { useNavigate } from "react-router-dom";
import { ResponsiveFormHost } from "../components/shared/ResponsiveFormHost";
import { EventForm } from "../components/events/EventForm";
import { useEvents } from "../context/EventContext";
import type { CurrencyCode } from "../types";

export function CreateEventPage() {
  const navigate = useNavigate();
  const { createEvent } = useEvents();

  const handleSubmit = (name: string, currency: CurrencyCode) => {
    const newEvent = createEvent(name, currency);
    navigate(`/event/${newEvent.id}`, { replace: true });
  };

  const handleCancel = () => {
    navigate("/");
  };

  return (
    <ResponsiveFormHost title="Nuevo evento" parentRoute="/">
      <EventForm onSubmit={handleSubmit} onCancel={handleCancel} />
    </ResponsiveFormHost>
  );
}
